import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {GRAY_LIGHTER} from 'ui-library/Colors';

import StepConfigFieldsTemplate from './StepConfigFieldsTemplate';
import useTaggedUnionFields, {TaggedUnionFieldsOptions} from './useTaggedUnionFields';

export type TaggedUnionEditorProps = TaggedUnionFieldsOptions;

export default function TaggedUnionEditor(props: TaggedUnionEditorProps): JSX.Element {
  const {tagField, choiceFields, selectedChoice, isSingleChoice} = useTaggedUnionFields(props);

  const fields = isSingleChoice
    ? choiceFields
    : selectedChoice == null
      ? [tagField]
      : [tagField, ...choiceFields];

  return (
    <div className={css(!isSingleChoice && styles.taggedUnionWrapper)}>
      <StepConfigFieldsTemplate numColumns={fields.length === 1 ? 1 : 2} fields={fields} />
    </div>
  );
}

const styles = StyleSheet.create({
  taggedUnionWrapper: {
    backgroundColor: GRAY_LIGHTER,
    borderRadius: 4,
    padding: 8,
    marginBottom: 8,
  },
});
